import React from 'react';
import BaseIcon from './BaseIcon.js';

const IconCurrency = function ({ size }) {
  return (
    <BaseIcon viewBox="0 0 24 24" size={size}>
      <g>
        <path d="M0 0h24v24H0z" fill="none">
        </path>
        <path d="M23 12v2c0 3.314-4.925 6-11 6-5.967 0-10.824-2.591-10.995-5.823L1 14v-2c0 3.314 4.925 6 11 6s11-2.686 11-6zM12 4c6.075 0 11 2.686 11 6s-4.925 6-11 6-11-2.686-11-6 4.925-6 11-6z">
        </path>
      </g>
    </BaseIcon>
  );
}

export default IconCurrency;
